module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('navbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoggedIn),
      expression: "isLoggedIn"
    }]
  }), _c('section', {
    staticClass: "section is-paddingless"
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless"
  }, [_c('router-view')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93315f94"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 442
// module chunks = 0